import type { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react'

import cn from '@components/utils/cn'

type EmbedButtonStyle = {
  color?: 'brand' | 'neutral'
  outline?: boolean
  size?: 'md' | 'lg'
}

function embedButtonClasses({ color = 'brand', outline = false, size = 'md' }: EmbedButtonStyle) {
  return cn(
    'tw:inline-flex tw:cursor-pointer tw:items-center tw:justify-center tw:gap-1.5 tw:whitespace-nowrap tw:rounded-(--embed-radius-sm,0.5rem) tw:text-sm tw:no-underline tw:aria-disabled:cursor-not-allowed',
    'tw:focus-visible:outline tw:focus-visible:outline-2 tw:focus-visible:outline-offset-2 tw:focus-visible:outline-(--embed-brand-ink,#111827)',
    size === 'lg' ? 'tw:h-12 tw:px-3 tw:font-medium' : 'tw:px-3.5 tw:py-2 tw:font-semibold',
    color === 'brand' &&
      (outline
        ? 'tw:border tw:border-(--embed-brand) tw:text-(--embed-brand-ink)'
        : 'tw:bg-(--embed-brand) tw:text-(--embed-brand-text)'),
    color === 'neutral' &&
      (outline
        ? 'tw:border tw:border-gray-300 tw:bg-white tw:text-gray-700 tw:hover:bg-gray-50'
        : 'tw:bg-gray-100 tw:text-gray-900 tw:hover:bg-gray-200')
  )
}

export function EmbedButton({
  color,
  outline,
  size,
  type = 'button',
  ...props
}: EmbedButtonStyle & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'color' | 'className'>) {
  return <button type={type} {...props} className={embedButtonClasses({ color, outline, size })} />
}

export function EmbedLink({
  color,
  outline,
  size,
  ...props
}: EmbedButtonStyle & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'color' | 'className'>) {
  return <a {...props} className={embedButtonClasses({ color, outline, size })} />
}
